import { JsonProperty } from 'json-object-mapper';

export class ValidateVoucherOutput {
  @JsonProperty() public valid: boolean;

  public constructor() {
    this.valid = null;
  }
}
